export enum CompressionType {
    None,
    Bzip2,
    Gzip,
}
